import Splide from '@splidejs/splide';

const EL = '.js-footer-carousel';

document.querySelectorAll('.js-footer-carousel').forEach((carousel) => {
  const slider = new Splide(carousel, {
    type: 'loop',
    arrows: false,
    pagination: true,
    gap: 30,
    perPage: 3,
    perMove: 1,
    breakpoints: {
      1366: {

      },
      1024: {
        gap: 20,
        perPage: 2,
      },
      767: {
        perPage: 1,
      },
    },
  });

  slider.mount();
});
